<div class="modal fade pass-back" id="sharee2" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header modal-pepsico-header">
        <h1 class="modal-title fs-5" id="exampleModalLabel"><b>VALIDACIÓN EXITOSA</b></h1>
      </div>
      <div class="modal-body text-center">
        <div class="order-tracking-unique">
          <div class="order-tracking-container-unique jf-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"
              class="bi bi-check-circle-fill check-pass-share" viewBox="0 0 16 16">
              <path
                d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
            </svg>
            <p class="mb-4">
              <b>Carlos</b> te ha compartido el catálogo. Navega y agrega a tus favoritos los artículos que más
              te gusten.
            </p>
          </div>
          <div class="d-flex jf-center">
            <button type="button" class="btn btn-primary perfilbtn-pep" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal-header modal-pepsico-header">
  <h1 class="modal-title fs-5" id="exampleModalLabel">BIENVENIDO</h1>
</div>
<div class="modal-body text-center">
  <div class="order-tracking-unique">
    <div class="order-tracking-container-unique jf-center">
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor"
        class="bi bi-check-circle-fill check-pass-share text-center" viewBox="0 0 16 16">
        <path
          d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
      </svg>
      <p class="mb-4">
        <b>{{this.name()}}</b> te ha compartido el catálogo. Navega y agrega a tus favoritos los artículos que más
        te gusten.
      </p>
    </div>
    <div class="d-flex jf-center">
      <button type="button" class="btn btn-primary perfilbtn-pep" (click)="closeModal()">Cerrar</button>
    </div>
  </div>
</div>